import { LaboratoryActionTypes } from './lab-actions';

export const initialState = {
  hashedLabId: undefined,
  laboratoryData: undefined,
  hashedServiceTypeId: undefined,
  serviceTypeTitle: undefined,
  serviceTypeSlug: undefined,
  selectedCity: undefined,
  hashedCityId: undefined,
  selectServiceId: undefined,
  selectedServiceDetail: {
    price: undefined,
    priceAffix: undefined,
    title: undefined,
  },
  cityItems: [],
  orderCount: 0,
  isTestItemsLoading: false,
  totalPrice: undefined,
  recipients: {
    '1': '',
  },
  recipientsValidation: false,
  recipientsError: false,
  recipientsErrorMessage: 'نام آزمایش دهنده الزامی است',
  selectedServiceDescription: [],
  storeLabLoading: false,
  dataValidation: false,
  labTestResultId: undefined,
  labTestResultLoading: false,
  labTestResult: undefined,
  clientSuggestedType: '1',
  clientSuggestedTime: undefined,
  clientSuggestedRange: undefined,
  prescriptionFile: undefined,
  prescriptionText: '',
  checkoutLoading: true,
  cityModal: false,
  selectedServiceId: null,
  selectedServiceSlug: null,
  prescriptionTerms: false,
};

function laboratoryReducer(state = initialState, action: any) {
  switch (action.type) {
    case LaboratoryActionTypes.SET_INITIAL_STORE: {
      return {
        ...state,
        hashedLabId: action?.data?.hashedLabId,
        laboratoryData: action?.data?.laboratoryData,
        hashedCityId: action?.data?.hashedCityId,
        selectedCity: action?.data?.selectedCity,
        hashedServiceTypeId: action?.data?.hashedServiceTypeId,
        serviceTypeTitle: action?.data?.serviceTypeTitle,
        serviceTypeSlug: action?.data?.serviceTypeSlug,
        cityItems: action?.data?.cityItems,
      };
    }

    case LaboratoryActionTypes.SET_SERVICE_TYPES:
      return {
        ...state,
        laboratoryData: action?.data?.laboratoryData,
        isTestItemsLoading: false,
      };

    case LaboratoryActionTypes.GET_SERVICE_TYPES:
      return {
        ...state,
        hashedCityId: action?.data?.hashedCityId,
        selectServiceId: initialState.selectServiceId,
        selectedCity: action?.data?.selectedCity,
        orderCount: initialState.orderCount,
        selectedServiceDetail: initialState.selectedServiceDetail,
        totalPrice: initialState.totalPrice,
        isTestItemsLoading: true,
      };

    case LaboratoryActionTypes.SET_SELECTED_SERVICE:

      let recipients = JSON.parse(JSON.stringify(state.recipients));

      if (action?.data?.orderCount > Object.keys(state.recipients).length) {
        recipients = Object.assign({}, state.recipients, {
          [action?.data?.orderCount]: '',
        });
      } else if (action?.data?.orderCount !== 1) {
        delete recipients[state.orderCount];
      } else {
        recipients = {
          '1': '',
        };
      }
      return {
        ...state,
        selectServiceId: action?.data?.orderCount ? action?.data?.selectServiceId : initialState.selectServiceId,
        orderCount: action?.data?.orderCount,
        selectedServiceDetail: action?.data?.selectedServiceDetail,
        totalPrice: action?.data?.selectedServiceDetail.price * action?.data?.orderCount,
        recipients: recipients,
      };

    case LaboratoryActionTypes.SET_RECIPIENTS_LIST:
      return {
        ...state,
        recipients: {
          ...state.recipients,
          [action?.data?.id]: action?.data?.text,
        },
        recipientsValidation: action?.data?.recipientsValidation && !!action?.data?.text,
      };

    case LaboratoryActionTypes.SET_TEST_DESCRIPTION:
      return {
        ...state,
        selectedServiceDescription: action?.data?.selectedServiceDescription,
      };

    case LaboratoryActionTypes.STORE_LAB_DATA:
      return {
        ...state,
        storeLabLoading: true,
      };

    case LaboratoryActionTypes.SET_STORE_LOADING:
      return {
        ...state,
        storeLabLoading: false,
      };

    case LaboratoryActionTypes.CHECK_DATA_VALIDATION:
      let recipientsError = false;

      for (const property in state.recipients) {
        // @ts-ignore
        if (!state.recipients[property]) {
          recipientsError = true;
          break;
        }
      }

      return {
        ...state,
        recipientsError: recipientsError,
        dataValidation: false,
      };

    case LaboratoryActionTypes.GET_QUERY_PARAMS: {
      let recipients: any = initialState.recipients;

      for (let i = 1; i <= action?.data?.orderCount; i++) {
        recipients = Object.assign(state.recipients, {
          [i]: '',
        });
      }

      return {
        ...state,
        hashedLabId: action?.data?.hashedLabId,
        selectServiceId: action?.data?.selectServiceId,
        hashedServiceTypeId: action?.data?.serviceSubTypeId,
        orderCount: action?.data?.orderCount,
        serviceTypeTitle: action?.data?.serviceTypeTitle,
        serviceTypeSlug: action?.data?.serviceTypeSlug,
        recipients: recipients,
      };
    }

    case LaboratoryActionTypes.SET_CLIENT_SUGGESTED_TYPE:
      return {
        ...state,
        clientSuggestedType: action?.data?.clientSuggestedType,
        clientSuggestedTime: undefined,
        clientSuggestedRange: undefined,
      };

    case LaboratoryActionTypes.SET_CLIENT_SUGGESTED_TIME:
      return {
        ...state,
        clientSuggestedTime: action?.data?.clientSuggestedTime,
      };

    case LaboratoryActionTypes.SET_CLIENT_SUGGESTED_RANGE:
      return {
        ...state,
        clientSuggestedRange: action?.data?.clientSuggestedRange,
      };

    case LaboratoryActionTypes.SET_SHOPPING_CART_INITIAL_STATE:
      return {
        ...state,
        selectServiceId: initialState.selectServiceId,
        selectedServiceDetail: initialState.selectedServiceDetail,
        orderCount: initialState.orderCount,
      };

    case LaboratoryActionTypes.SET_PRESCRIPTION_TEXT:
      return {
        ...state,
        prescriptionText: action?.data?.prescriptionText,
      };

    case LaboratoryActionTypes.SET_PRESCRIPTION_FILE:
      return {
        ...state,
        prescriptionFile: action?.data?.prescriptionFile,
      };

    case LaboratoryActionTypes.STORE_PRESCRIPTION_DATA:
      return {
        ...state,
        storeLabLoading: true,
      };

    case LaboratoryActionTypes.SET_PRESCRIPTION_INITIAL:
      return {
        ...state,
        prescriptionFile: initialState.prescriptionFile,
        prescriptionText: initialState.prescriptionText,
      };

    case LaboratoryActionTypes.SET_CHECKOUT_LOADING:
      return {
        ...state,
        checkoutLoading: action?.data?.loading,
      };

    case LaboratoryActionTypes.SET_CITY_MODAL:
      return {
        ...state,
        cityModal: action?.data?.open,
        selectedServiceId: action?.data?.labId || null,
        selectedServiceSlug: action?.data?.slug || null,
      };

    case LaboratoryActionTypes.SET_PRESCRIPTION_TERMS:
      return {
        ...state,
        prescriptionTerms: action?.data?.prescriptionTerms,
      };

    default:
      return state;
  }
}

export default laboratoryReducer;
